<template>
    <div class="support-plan-cart">
        <h4 class="step-title">Plan Cart</h4>
        <div class="strategies">
            <draggable class="dragArea strategy"
                       :options="{handle: '.drag-handle'}"
                       v-model="docData.strategies">
                <b-card no-body class="mb-3"
                        v-for="s in docData.strategies">
                    <b-card-body>
                        <b-row class="align-items-center">
                            <b-col cols="2">
                                <open-icon name="resize-height" class="drag-handle"></open-icon>
                            </b-col>
                            <b-col cols="10">
                                <b-row class="category-crumbs">
                                    <span class="category-crumbs__level-one">{{ s.categoryTitle }}</span>
                                    <span class="crumb-separator"> / </span>
                                    <span class="category-crumbs__level-two">{{ s.subjectTitle }}</span>
                                    <span class="crumb-separator"> / </span>
                                    <br/>
                                    <span class="category-crumbs__level-three">{{ s.strategy.title }}</span>
                                </b-row>
                                <b-row class="strategy__buttons">
                                    <b-btn variant="primary" size="sm"
                                           @click="openEditStrategyModal(s)" class="btn-icon-small mr-4">
                                        <open-icon name="pencil"></open-icon>
                                    </b-btn>
                                    <b-btn variant="danger" size="sm"
                                           @click="removeStrategy(s)" class="btn-icon-small">
                                        <open-icon name="delete"></open-icon>
                                    </b-btn>
                                </b-row>
                            </b-col>

                        </b-row>

                    </b-card-body>
                </b-card>
            </draggable>

            <!-- view strategy modal -->

            <b-modal hide-footer size="lg"
                     id="edit-strategy-modal"
                     title="Edit Strategy">

                <div v-if="currentStrategy">
                    <!-- for custom strategy, allow editing of all fields
                        (except annotations, which are not supported in this case) -->
                    <template v-if="currentStrategy.strategy.isCustom">
                        <b-form-group label="Strategy Title">
                            <b-form-input type="text"
                                          v-model="currentStrategy.strategy.title"></b-form-input>
                        </b-form-group>

                        <b-form-group label="Text">
                            <b-form-textarea rows="10"
                                             v-model="currentStrategy.strategy.text"></b-form-textarea>
                        </b-form-group>

                        <b-form-group label="Your Notes">
                            <b-form-textarea rows="5"
                                             v-model="currentStrategy.notes"></b-form-textarea>
                        </b-form-group>

                        <b-form-group label="Links">
                            <b-form-textarea rows="5"
                                             v-model="currentStrategy.strategy.links"></b-form-textarea>
                        </b-form-group>
                    </template>
                    <!-- for non-custom strategy, only allow editing of notes -->
                    <template v-else>
                        <h3>
                            {{ currentStrategy.strategy.title }}
                        </h3>
                        <p class="show-line-breaks">
                            {{ currentStrategy.strategy.text }}
                        </p>
                        <b-row>
                            <b-col sm="12">
                                <h5>Your Notes</h5>
                                <b-form-textarea v-model="currentStrategy.notes" class="mb-3">
                                </b-form-textarea>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="6">
                                <h5>Annotations</h5>
                                <p v-for="aid in currentStrategy.strategy.annotations">
                                    {{ getAnnotation(aid).text }}
                                </p>
                            </b-col>
                            <b-col sm="6">
                                <h5>Links</h5>
                                <p v-html="currentStrategy.strategy.links">
                                </p>
                            </b-col>
                        </b-row>
                    </template>

                    <b-row class="mt-3">
                        <b-col class="text-left">
                            <b-btn variant="danger"
                                   @click="removeStrategy(currentStrategy)">
                                Remove from Cart
                            </b-btn>
                        </b-col>
                        <b-col class="text-right">
                            <b-btn variant="success"
                                   @click="closeEditStrategyModal()">
                                Update
                            </b-btn>
                        </b-col>
                    </b-row>
                </div>

            </b-modal>

        </div>

    </div>
</template>

<script>

    import Vue from 'vue'
    import draggable from 'vuedraggable'
    import ToolMixin from '@/providers/ToolMixin'
    import SupportPlanMixin from "../providers/SupportPlanMixin";

    export default Vue.extend({
        name: "SupportPlanCart",
        mixins: [ToolMixin, SupportPlanMixin],
        components: {
            draggable,
        },
        data() {
            return {
                // NB: this is a wrapper - { categoryTitle: ..., subjectTitle: ..., strategy: ... }
                currentStrategy: null,
            }
        },
        methods: {
            openEditStrategyModal(strategy) {
                this.currentStrategy = strategy
                this.$bvModal.show('edit-strategy-modal')
            },
            closeEditStrategyModal() {
                this.$bvModal.hide('edit-strategy-modal')
            },
            async removeStrategy(s) {
                const msg = s.strategy.isCustom ?
                    'Remove strategy from Cart? Since this is a custom strategy, all text you have entered for it will be permanently deleted!' :
                    'Remove strategy from Cart?'
                const ok = await this.$bvModal.msgBoxConfirm(msg)
                if (ok) {
                    this.docData.strategies = _.without(this.docData.strategies, s)
                    this.closeEditStrategyModal()
                }
            }
        }
    })

</script>

<style lang="scss">

    @import 'sass/variables_mixins';

    .support-plan-cart .card-body {
        background-color: $light-neutral-bg !important;
    }

    .strategies {
        @media (min-width: 1000px) {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            .strategy {
                width: 49%;
            }
        }
    }

    .strategy__buttons {
        margin-top: 1em;
    }

    .category-crumbs {
        font-size: 14px;
    }

    .category-crumbs__level-three {
        text-transform: uppercase;
    }

</style>